export default {
  component: () => import('./notFound.component'),
};
